module.exports = __webpack_public_path__ + "Poppins-Black.8d92a75cb243049317c6.woff";


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/src/assets/vendors/base/fonts/googleapi-fonts/Poppins-Black.woff
// module id = ../../../../../src/assets/vendors/base/fonts/googleapi-fonts/Poppins-Black.woff
// module chunks = styles